/**
 * CollapsibleSection Component
 *
 * A collapsible section for organizing config panel content.
 */

import React, { useState } from 'react';
import Typography from 'Components/DesignSystem/Typography/Typography';

interface CollapsibleSectionProps {
  title: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

export const CollapsibleSection = ({
  title,
  defaultOpen = false,
  children,
}: CollapsibleSectionProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="tw-border tw-border-edge tw-rounded tw-mt-4">
      <button data-testid="configpanel-collapsiblesection-button-1"
        type="button"
        className="tw-w-full tw-flex tw-items-center tw-justify-between tw-px-3 tw-py-2 tw-bg-surface-sunken hover:tw-bg-surface-hover tw-transition-colors tw-rounded-t"
        onClick={() => setIsOpen(!isOpen)}
      >
        <Typography variant="sub-title-label" className="tw-text-ink">
          {title}
        </Typography>
        <svg
          className={`tw-w-4 tw-h-4 tw-text-ink-secondary tw-transition-transform ${
            isOpen ? 'tw-rotate-180' : ''
          }`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {isOpen && (
        <div className="tw-p-3 tw-border-t tw-border-edge">
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
